/**
 * Labstep
 *
 * @module components/Folder/Form/fields
 * @desc Form Fields for Folder
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import rules from 'labstep-web/services/validation/rules';
import { mixed } from 'yup';

export const fieldName: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  fieldLabel: 'Name',
  name: 'name',
  validation: rules.folder.name,
  placeholder: 'Enter name',
};

export const fieldNameMultiple: FieldWithoutActionProps = {
  fieldLabel: 'Names',
  name: 'names',
  validation: mixed().required(),
  placeholder: 'Enter name',
  fieldType: FieldType.SelectMulti,
};
